import { Routes } from '@angular/router';
import { coreRoutes } from './components/core.routes';
import { userDocumentationRoutes } from './components/user-documentation.routes';
import { ordersRoutes } from './components/orders/orders.routes';
import { orderTemplatesRoutes } from './components/order-templates/order-templates.routes';
import { maintenanceContractsRoutes } from './components/maintenance-contracts/maintenance-contracts.routes';
import { weeklyViewRoutes } from './components/weekly-view/weekly-view.routes';
import { measurementsRoutes } from './components/measurements/measurements.routes';
import { appointmentTypesRoutes } from './components/appointment-types/appointment-types.routes';
import { avvRoutes } from './components/avv/avv.routes';
import { employeesRoutes } from './components/employees/employees.routes';
import { usersRoutes } from './components/users/users.routes';
import { vehiclesRoutes } from './components/vehicles/vehicles.routes';
import { serviceItemsRoutes } from './components/service-items/service-items.routes';
import { revenueAccountsRoutes } from './components/revenue-accounts/revenue-accounts.routes';
import { frameworkContractsRoutes } from './components/framework-contracts/framework-contracts.routes';
import { wasteNotificationsRoutes } from './components/waste-notifications/waste-notifications.routes';
import { reportsRoutes } from './components/reports/reports.routes';
import { contactsRoutes } from './components/contacts/contacts.routes';

export const routes: Routes = [
  ...coreRoutes,
  ...userDocumentationRoutes,
  ...ordersRoutes,
  ...orderTemplatesRoutes,
  ...maintenanceContractsRoutes,
  ...weeklyViewRoutes,
  ...measurementsRoutes,
  ...appointmentTypesRoutes,
  ...avvRoutes,
  ...employeesRoutes,
  ...usersRoutes,
  ...vehiclesRoutes,
  ...serviceItemsRoutes,
  ...revenueAccountsRoutes,
  ...frameworkContractsRoutes,
  ...wasteNotificationsRoutes,
  ...reportsRoutes,
  ...contactsRoutes,
  { path: '**', redirectTo: '/dashboard' },
];
